import React from 'react'

const getFieldCSSClasses = (touched: boolean, errors: string | React.ReactNode) => {
  const classes = ['form-control']
  if (touched && errors) {
    classes.push('is-invalid ')
  }

  return classes.join(' ')
}

export function Input({
  field, // { name, value, onChange, onBlur }
  form: {touched, errors, submitCount}, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  form,
  label,
  withFeedbackLabel = true,
  type = 'text',
  required,
  rightInputAction,
  ...props
}: InputProps) {
  if (submitCount && field && field.name) {
    touched[field.name] = true
  }

  // Safety check for field object
  if (!field) {
    return <div>Loading...</div>
  }

  return (
    <div className='my-1'>
      {label && <label className={`pb-1 fw-bold ${required ? 'required' : ''}`}>{label}</label>}
      <div className='position-relative d-flex align-items-center'>
        <input
          {...field}
          {...props}
          type={type}
          className={
            withFeedbackLabel && field.name
              ? getFieldCSSClasses(touched[field.name], errors[field.name])
              : 'form-control'
          }
        />
        {rightInputAction && (
          <div className='position-absolute z-1' style={{right: '40px'}}>
            {rightInputAction}
          </div>
        )}
      </div>

      {field.name && touched[field.name] && errors[field.name] ? (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block py-2'>
            <span className='text-danger fw-bold' role='alert'>
              {errors[field.name]}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

interface InputProps {
  field: any
  form: any
  label?: String | React.ReactNode
  withFeedbackLabel?: boolean
  type: string
  required?: boolean
  rightInputAction?: React.ReactNode
}
